import axios from "axios";

const instance = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL, // ✅ from .env
});

/* ================= REQUEST ================= */
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");

    // 🔒 Attach token only for protected API routes
    if (token && config.url.startsWith("/api")) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

/* ================= RESPONSE ================= */
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    // 🔴 If token expired or invalid
    if (error.response && error.response.status === 401) {
      localStorage.removeItem("token");

      // ✅ Show message only once
      alert("Session expired. Please login again.");

      // ✅ Redirect only if user is in admin panel
      if (window.location.pathname.startsWith("/admin")) {
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  }
);

export default instance;